import { useSelector } from 'react-redux';
import { ReducerKeys } from '..';
import { LanguagesEnum } from '../../../config/languages';

export const useSelectLanguageID = (): LanguagesEnum => {
  return useSelector(
    (state: any) => state[ReducerKeys.TRANSL_REDUCER].language
  );
};
